// it would be better to decompose
nsr.factory('VintCollectionService', ['Admin', 'TransitionService', function (Admin, TransitionService) {
    const VintCollectionService = {
        collections: [],
        collection: {},
        collectionId: null,
        setCollection: function (collection) {
            if (collection === null) {
                this.collection = null;
                this.collectionId = null;
                return;
            }

            this.collection = collection;
            this.collectionId = collection.id
        },
        getCollection: function () {
            return this.collection;
        }
    };

    // move to another service
    VintCollectionService.doRefreshTrigger = false

    VintCollectionService.edit = function (collection) {
        return Admin.put('vint-collections/' + collection.id, collection)
            .success(function () {
                VintCollectionService.doRefreshTrigger = true;
            })
            .error(function (response) { bootbox.alert(response.errors[0]); }
            );
    };

    VintCollectionService.create = function (collection) {
        return Admin.post('vint-collections', collection)
            .success(function () {
                VintCollectionService.doRefreshTrigger = true;
            })
            .error(function (response) {
                    bootbox.dialog({
                        message: ErrorHandler.format(),
                        title: 'Error Saving Collection',
                        buttons: {
                            main: {
                                label: "Ok",
                                className: "btn-primary",
                                callback: function () { }
                            }
                        }
                    });
                }
            );
    };

    VintCollectionService.deleteCollection = function (collection_id) {
        TransitionService.showToastUntilCompleted(Admin.delete('vint-collections/' + collection_id), "Deleting collection...").then(function () {
            VintCollectionService.doRefreshTrigger = true
        })
    }

    return VintCollectionService
}]);

nsr.factory('VintAccountService', ['$log', 'Admin', 'TransitionService', 'ErrorHandler', '$timeout', 'MessageService', function ($log, Admin, TransitionService, ErrorHandler) {

    const VintAccountService = {
        accounts: [],
        account: {}
    };

    VintAccountService.create = function (account) {
        return Admin.post('vint-save', account)
            .success(function () {
            })
            .error(function (response) {
                    bootbox.dialog({
                        message: ErrorHandler.format(),
                        title: 'Error Saving Account',
                        buttons: {
                            main: {
                                label: "Ok",
                                className: "btn-primary",
                                callback: function () { }
                            }
                        }
                    });
                }
            );
    };

    VintAccountService.buy = function (account, model) {

        model.share_price = model.collection.share_price
        model.collection = model.collection.id

        return Admin.post('vint-buy/' + account.account_id, model)
            .success(function () {
            })
            .error(function (response) {
                    bootbox.dialog({
                        message: ErrorHandler.format(),
                        title: 'Error Saving Shares',
                        buttons: {
                            main: {
                                label: "Ok",
                                className: "btn-primary",
                                callback: function () { }
                            }
                        }
                    });
                }
            );
    };

    return VintAccountService;
}]);